<mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded w-64">
    <mat-select multiple [formControl]="filterCountryInputControl" placeholder="All Country"
        (selectionChange)="onSelectCountry($event.value)">
        <div class="px-4 pt-5 sticky top-0 z-10 w-full bg-white">
            <mat-form-field class="w-full">
                <input matInput placeholder="Search" #countryZoneSearch>
            </mat-form-field>
        </div>
        <!-- Select All Option -->
        <mat-select-trigger>
            {{filterCountryInputControl.value?.[0] | GetCountryNameByCode: allCountryZone}}
            <span *ngIf="(filterCountryInputControl.value?.length || 0) > 1">
                (+{{(filterCountryInputControl.value?.length || 0) - 1}} {{filterCountryInputControl.value?.length === 2
                ? 'other' : 'others'}})
            </span>
        </mat-select-trigger>
        <option *ngIf="!countryZoneSearch.value"
            class="w-full border-b-2 border-t-2 px-4 py-2 cursor-pointer hover:bg-primary-50"
            [selected]="isAllSelected()" (click)="toggleSelectAll()">
            {{isAllSelected() ? 'Deselect All' : 'Select All'}}
        </option>
        <mat-option
            *ngFor="let country of allCountryZone | searchByKey: ['name']: countryZoneSearch.value; trackBy: trackByFn"
            [value]="country.countryZoneCode">
            {{country.name}}
        </mat-option>
    </mat-select>
</mat-form-field>